import { useState } from 'react';
import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { apiFetch, apiFetchBlob } from '../api/client.js';

export function PaymentConfirmationPanel({ id, status }: { id: string; status: string }): JSX.Element {
  const [busy, setBusy] = useState(false), [failure, setFailure] = useState('');
  const confirmation = useQuery({ queryKey: ['payment-confirmation', id, status],
    queryFn: () => apiFetch<{ available: boolean; reason?: string }>(`/admin/withdrawals/${id}/confirmation/status`),
    enabled: status === 'SENT' });
  const download = async (): Promise<void> => {
    setBusy(true); setFailure('');
    try {
      const blob = await apiFetchBlob(`/admin/withdrawals/${id}/confirmation`), url = URL.createObjectURL(blob);
      const link = document.createElement('a'); link.href = url; link.download = `Norvix-payment-${id}.pdf`; link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) { setFailure(error instanceof Error ? error.message : 'The confirmation could not be downloaded.'); void confirmation.refetch(); }
    finally { setBusy(false); }
  };
  return <Paper variant="outlined" sx={{ p: 2.5 }}><Stack spacing={1.5}>
    <Typography variant="subtitle1" fontWeight={700}>Payment confirmation</Typography>
    <Typography variant="body2" color="text.secondary">{status !== 'SENT' ? 'Available after bank completion. Approval or submission alone does not enable a confirmation.'
      : confirmation.isPending ? 'Checking bank completion…' : confirmation.data?.available ? 'The payment completion record is available as a PDF.'
        : confirmation.data?.reason || 'Bank completion could not be verified.'}</Typography>
    {confirmation.isError && <Alert severity="error" action={<Button onClick={() => void confirmation.refetch()}>Retry</Button>}>Confirmation status could not be loaded.</Alert>}
    {failure && <Alert severity="error">{failure}</Alert>}
    <Button variant="outlined" startIcon={<DownloadOutlinedIcon />} sx={{ alignSelf: 'flex-start' }} disabled={!confirmation.data?.available || status !== 'SENT' || busy} onClick={() => void download()}>
      {busy ? 'Preparing PDF…' : 'Download confirmation (PDF)'}
    </Button>
  </Stack></Paper>;
}
